import React, { Component } from 'react'

export default class Default extends Component {
  render() {
    return (
      <div className="align-items-center vh-100 d-flex text-center">
        <div className="text-center w-100">
          <h1>404</h1>
          <h3 >Oops, I don't know where to find that.</h3  >
        </div>
      </div>
    )
  }
}
